<template>
  <div class="product-form-v2">
    <div class="form-layout-v2">
      <div class="form-sidebar-v2">
        <div class="form-panels-v2" id="accordionExample">
          <!-- Параметри замовлення -->
          <div class="panel-card-v2">
            <div class="panel-header-v2" id="headingFour" data-toggle="collapse" data-target="#collapseFour"
              aria-expanded="false" aria-controls="collapseFour">
              <div class="panel-title-v2">
                <i class="fa fa-cog"></i>
                <span>Параметри замовлення</span>
              </div>
              <i class="fa fa-chevron-down panel-arrow-v2"></i>
            </div>
            <div id="collapseFour" class="panel-content-v2 collapse" aria-labelledby="headingFour"
              data-parent="#accordionExample">

              <div class="checkbox-grid-v2">
                <div class="checkbox-item-v2">
                  <input type="checkbox" class="checkbox-v2" id="customer_material" v-model="customer_material"
                    value="true">
                  <label for="customer_material" class="checkbox-label-v2">
                    <i class="fa fa-cube"></i>
                    Матеріал Клієнта
                  </label>
                </div>

                <div class="checkbox-item-v2">
                  <input type="checkbox" class="checkbox-v2" id="customer_edge" v-model="customer_edge" value="true">
                  <label for="customer_edge" class="checkbox-label-v2">
                    <i class="fa fa-border-style"></i>
                    Кромка Клієнта
                  </label>
                </div>

                <div class="checkbox-item-v2">
                  <input type="checkbox" class="checkbox-v2" id="edge_size" value="true" v-model="edge_size">
                  <label for="edge_size" class="checkbox-label-v2">
                    <i class="fa fa-ruler-combined"></i>
                    Розмір з Кромкою
                  </label>
                </div>

                <div class="checkbox-item-v2">
                  <input type="checkbox" class="checkbox-v2" id="glue" v-model="glue" value="true">
                  <label for="glue" class="checkbox-label-v2">
                    <i class="fa fa-spray-can"></i>
                    Оклеювання клеєм PUR
                  </label>
                </div>
              </div>
            </div>

          </div>


          <!-- Назва виробу -->
          <div class="panel-card-v2">
            <div class="panel-header-v2" id="headingName" data-toggle="collapse" data-target="#collapseName"
              aria-expanded="false" aria-controls="collapseName">
              <div class="panel-title-v2">
                <i class="fa fa-tag"></i>
                <span>Назва виробу</span>
              </div>
              <i class="fa fa-chevron-down panel-arrow-v2"></i>
            </div>

            <div id="collapseName" class="panel-content-v2 collapse" aria-labelledby="headingName"
              data-parent="#accordionExample">
              <div class="input-group-v2" style="padding: 12px;">
                <input type="text" v-model="productName" placeholder="Введіть назву виробу" class="form-input-v2" />
              </div>
            </div>
          </div>

          <!-- Матеріали -->
          <div class="panel-card-v2">
            <div class="panel-header-v2" id="headingOne" data-toggle="collapse" data-target="#collapseOne"
              aria-expanded="true" aria-controls="collapseOne">
              <div class="panel-title-v2">
                <i class="fa fa-cube"></i>
                <span>Матеріали</span>
              </div>
              <i class="fa fa-chevron-down panel-arrow-v2"></i>
            </div>

            <div id="collapseOne" class="panel-content-v2 collapse show" aria-labelledby="headingOne"
              data-parent="#accordionExample">
              <div class="component-wrapper-v2">
                <materials :toSearch="toSearch" :materialsDefault="materialsDefault" @interface="toSearch = $event"
                  :materials="materials" />
              </div>
            </div>
          </div>

          <!-- Кромки -->
          <div class="panel-card-v2">
            <div class="panel-header-v2" id="headingTwo" data-toggle="collapse" data-target="#collapseTwo"
              aria-expanded="false" aria-controls="collapseTwo">
              <div class="panel-title-v2">
                <i class="fa fa-border-style"></i>
                <span>Кромки</span>
              </div>
              <i class="fa fa-chevron-down panel-arrow-v2"></i>
            </div>
            <div id="collapseTwo" class="panel-content-v2 collapse" aria-labelledby="headingTwo"
              data-parent="#accordionExample">
              <div class="component-wrapper-v2">
                <edges :edgeDefault="edgeDefault" @interface="toSearch = $event" :edges="edges" :toSearch="toSearch" />
              </div>
            </div>
          </div>

          <!-- Стяжки -->
          <div class="panel-card-v2">
            <div class="panel-header-v2" id="headingThree" data-toggle="collapse" data-target="#collapseThree"
              aria-expanded="false" aria-controls="collapseThree">
              <div class="panel-title-v2">
                <i class="fa fa-link"></i>
                <span>Стяжки</span>
              </div>
              <i class="fa fa-chevron-down panel-arrow-v2"></i>
            </div>
            <div id="collapseThree" class="panel-content-v2 collapse" aria-labelledby="headingThree"
              data-parent="#accordionExample">
              <div class="component-wrapper-v2">
                <screeds :screeds="screeds" />
              </div>
            </div>
          </div>

          <!-- Кнопки дій -->
          <div class="action-buttons-v2">
            <button class="btn btn-outline-secondary btn-compact"
              :disabled="(this.details.length < 1) || loading || !is1cConnected" @click="validateOrder">
              <i class="fa fa-check-circle"></i>
              Перевірити
            </button>
            <button class="btn btn-success btn-compact" @click="save"
              :disabled="(this.details.length < 1) || loading">
              <i class="fa fa-save"></i>
              Зберегти
            </button>
          </div>
          <div v-if="!is1cConnected && connectionText" class="connection-status">
            <i class="fa fa-plug"></i>
            <span>{{ connectionText }}</span>
          </div>

        </div>
      </div>
      <div class="visual-section-v2">
        <div class="visual-card-v2">
          <div class="visual-header-v2">
            <h3><i class="fa fa-eye"></i> 2D Візуалізація</h3>
          </div>
          <div class="visual-content-v2">
            <visual :detail="selectedDetail" :edges="edges" :materials="materials" v-if="details.length" />
          </div>
        </div>
      </div>
    </div>

    <!-- Таблиця деталей -->
    <div class="table-section-v2">
      <div class="table-card-v2">
        <div class="table-header-v2">
          <div class="table-title-v2">
            <i class="fa fa-table"></i>
            Деталі
          </div>
          <button class="btn-v2 btn-outline-v2 btn-sm-v2" @click="showHotkeysHelp"
            :v-b-tooltip.hover.top="hotkeysTooltip">
            <i class="fa fa-keyboard"></i>
            {{ hotkeysButtonText }}
          </button>
        </div>
        <div class="table-content-v2">
          <form id="detailTableForm" class="table-wrapper-v2">
            <table id="main_table" class="main_table table table-bordered">
              <thead>
                <tr>
                  <th rowspan="2" style="min-width: 24px !important;">№</th>
                  <th rowspan="2" style="min-width:80px !important;">Опції</th>
                  <th :colspan="showEdgeSidesCount ? 2 : 1" style="min-width:62px !important;">Довжина</th>
                  <th :colspan="showEdgeSidesCount ? 2 : 1" style="min-width:62px !important;">Ширина</th>
                  <th rowspan="2" style="min-width:40px !important;">К-ть</th>
                  <th v-b-tooltip.hover.right title="Обертати" rowspan="2" style="min-width:30px !important;">
                    <span>
                      <i class="fa fa-sync"></i>
                      <br>
                      <i class="fa fa-xs fa-question-circle"></i>
                    </span>
                    <div class="checkbox-container">
                      <input type="checkbox" id="rotate_all" @change="rotateAll" class="checkbox-input">
                      <label for="rotate_all"></label>
                    </div>
                  </th>
                  <th colspan="4" style="min-width:720px !important;max-width:720px !important;">Кромка</th>
                  <th rowspan="2" style="min-width:242px !important;">Матеріал</th>
                  <th colspan="3" style="min-width:91px !important;">Стяжка</th>

                  <th rowspan="2" style="min-width:82px !important;">
                    <span>
                      Порізка за <br> текстурою
                    </span>
                  </th>
                  <th rowspan="2" style="min-width:120px !important;">Шаблон</th>
                  <th rowspan="2" style="min-width:110px !important;">Виріб</th>
                  <th rowspan="2" style="min-width:110px !important;">Деталь</th>
                </tr>
                <tr>
                  <td style="min-width:70px !important;">мм</td>
                  <td v-if="showEdgeSidesCount" v-b-tooltip.hover.right
                    title="Кількість сторін, що обклеюються, за довжиною" style="min-width:37px !important;">К
                    <i class="fa fa-xs fa-question-circle"></i>
                  </td>

                  <td style="min-width:70px !important;">мм</td>
                  <td v-if="showEdgeSidesCount" v-b-tooltip.hover.right
                    title="Кількість сторін, що обклеюються, за шириною" style="min-width:37px !important;">К
                    <i class="fa fa-xs fa-question-circle"></i>
                  </td>

                  <td style="min-width: 180px !important;max-width: 180px !important;">Верх</td>
                  <td style="min-width: 180px !important;max-width: 180px !important;">Низ</td>
                  <td style="min-width: 180px !important;max-width: 180px !important;">Ліворуч</td>
                  <td style="min-width: 180px !important;max-width: 180px !important;">Праворуч</td>

                  <td v-b-tooltip.hover.right
                    title="0 - Відсутня, 1-Звичайна, >1-Економ (Обов'язковий вибір Базової деталі 'БД')"
                    style="min-width: 62px !important;"> <span>
                      Тип <i class="fa fa-xs fa-question-circle"></i>
                    </span>
                  </td>
                  <td v-b-tooltip.hover.right title="Базова деталь для Економ стяжки" colspan="2"
                    style="min-width: 41px !important;">
                    БД
                    <i class="fa fa-xs fa-question-circle"></i>
                  </td>
                </tr>
              </thead>
              <tbody style="min-height:150px">
                <tr v-for="(detail, index) in details" :data-key="index" :key="index"
                  :class="index === activeIndex ? 'active' : ''" @keypress="visual(index)" @keyup="visual(index)"
                  @mousedown="visual(index)">
                  <td style="min-width: 24px !important;">{{ index + 1 }}</td>
                  <td style="min-width: 80px !important;">
                    <div class="btn-group">

                      <b-button type="button" size="sm" v-b-tooltip.hover.right="'Копіювати'" @click="copyDetail(index)"
                        variant="outline-info"><i class="far fa-copy"></i></b-button>

                      <b-button type="button" size="sm" variant="outline-danger" v-b-tooltip.hover.right="'Видалити'"
                        @click="removeDetail(index)">
                        <i class="far fa-trash-alt"></i>
                      </b-button>

                    </div>
                  </td>

                  <td style="min-width: 70px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'L_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'L_', detail)">
                    <input type="text" required step="0.1" min="20" max="9999.9" lang="en-150"
                      @keydown="handleNavigation" @keyup="onlyNumeric" @change="fixedLength(detail, 'length')"
                      v-model.number="detail.length" />
                  </td>
                  <td v-if="showEdgeSidesCount" style="min-width: 37px !important;">
                    <input type="text" required step="1" min="0" max="2" @keydown="handleNavigation"
                      v-model.number="detail.k1" @change="addEdge($event.target, index, 1)" class="sm-one" />
                  </td>
                  <td style="min-width: 70px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'W_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'W_', detail)">
                    <input type="text" step="0.1" min="20" required max="9999.9" lang="en-150"
                      @keydown="handleNavigation" @keyup="onlyNumeric" @change="fixedLength(detail, 'length')"
                      v-model.number="detail.width" />
                  </td>
                  <td v-if="showEdgeSidesCount" style="min-width: 37px !important;">
                    <input type="text" required step="1" min="0" max="2" @keydown="handleNavigation"
                      v-model.number="detail.k2" @change="addEdge($event.target, index, 2)" class="sm-one" />
                  </td>
                  <td style="min-width: 40px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'Qt_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'Qt_', detail)">
                    <input type="text" @keydown="handleNavigation" @keyup="onlyNumeric" required step="1" min="1"
                      lang="en-150" v-model.number="detail.count" class="one-qt" />
                  </td>
                  <td style="min-width: 30px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'Rotate_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'Rotate_', detail)">
                    <div class="checkbox-container">
                      <input type="checkbox" :id="'Rotate_' + index" class="checkbox-input"
                        v-model.number="detail.rotate" @keydown="handleNavigation"
                        @keydown.space="toggleCheckbox($event, 'rotate')"
                        @change="checkboxChange($event.target.checked, 'rotate')">
                      <label :for="'Rotate_' + index"></label>
                    </div>
                  </td>

                  <td style="min-width: 180px !important;max-width: 180px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'EdgeT_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'EdgeT_', detail)">
                    <select v-model="detail.edge_t" :style="getEdgeSelectStyle(detail.edge_t)"
                      class="custom-select material" @keydown="handleSelectNavigation($event, edges, 'edge_t')"
                      @change="procesK(detail)">
                      <option :value="null">Ні</option>
                      <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
                        {{ (i + 1) + ' ' }} {{ edge.full_name }}
                      </option>
                    </select>
                  </td>
                  <td style="min-width: 180px !important;max-width: 180px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'EdgeB_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'EdgeB_', detail)">
                    <select v-model="detail.edge_b" :style="getEdgeSelectStyle(detail.edge_b)"
                      class="custom-select material" @keydown="handleSelectNavigation($event, edges, 'edge_b')"
                      @change="procesK(detail)">
                      <option :value="null">Ні</option>
                      <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
                        {{ (i + 1) + ' ' }} {{ edge.full_name }}
                      </option>
                    </select>
                  </td>
                  <td style="min-width: 180px !important;max-width: 180px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'EdgeL_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'EdgeL_', detail)">
                    <select v-model="detail.edge_l" :style="getEdgeSelectStyle(detail.edge_l)"
                      class="custom-select material" @keydown="handleSelectNavigation($event, edges, 'edge_l')"
                      @change="procesK(detail)">
                      <option :value="null">Ні</option>
                      <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
                        {{ (i + 1) + ' ' }} {{ edge.full_name }}
                      </option>
                    </select>
                  </td>
                  <td style="min-width: 180px !important;max-width: 180px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'EdgeR_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'EdgeR_', detail)">
                    <select v-model="detail.edge_r" :style="getEdgeSelectStyle(detail.edge_r)"
                      class="custom-select material" @keydown="handleSelectNavigation($event, edges, 'edge_r')"
                      @change="procesK(detail)">
                      <option :value="null">Ні</option>
                      <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
                        {{ (i + 1) + ' ' }} {{ edge.full_name }}
                      </option>
                    </select>
                  </td>

                  <td style="min-width: 242px !important;max-width: 242px !important;">
                    <select v-model="detail.material" :style="getMaterialSelectStyle(detail.material)"
                      class="custom-select material" required
                      v-b-tooltip.hover.top="materials.find(edge => edge.ref === detail.material)?.full_name ?? ''"
                      @keydown="handleSelectNavigation($event, materials, 'material')"
                      @change="updateMaterial(index, $event.target.value)">
                      <option value="" disabled>Виберіть*</option>
                      <option v-for="(material, i) in materials" :value="material.ref" :key="i">
                        {{ (i + 1) + ' ' }} {{ material.full_name }}
                      </option>
                    </select>
                  </td>
                  <td style="min-width: 62px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'Screed_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'Screed_', detail)">
                    <select class="custom-select one" v-model.number="detail.screed"
                      @keydown="handleSelectNavigation($event, screeds, 'screed')">
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option v-for="(screed, i) in screeds" :value="screed" :key="i">{{ screed }}
                      </option>
                    </select>
                  </td>

                  <td style="min-width: 41px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'ScreedBP_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'ScreedBP_', detail)">
                    <div class="checkbox-container">
                      <input type="checkbox" :id="'ScreedBP_' + index" class="checkbox-input"
                        v-model.number="detail.screed_bp" @keydown="handleNavigation"
                        @keydown.space="toggleCheckbox($event, 'screed_bp')"
                        @change="checkboxChange($event.target.checked, 'screed_bp')">
                      <label :for="'ScreedBP_' + index"></label>
                    </div>
                  </td>

                  <td style="min-width: 82px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'CutToTxtrs_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'CutToTxtrs_', detail)">
                    <div class="checkbox-container">
                      <input type="checkbox" :id="'CutToTxtrs_' + index" @keydown="handleNavigation"
                        @keydown.space="toggleCheckbox($event, 'cut_to_txtrs')" class="checkbox-input"
                        v-model.number="detail.cut_to_txtrs"
                        @change="checkboxChange($event.target.checked, 'cut_to_txtrs')">
                      <label :for="'CutToTxtrs_' + index"></label>
                    </div>
                  </td>
                  <td style="min-width: 120px !important;"
                    :class="{ 'red tooltiper': detailValidation(detail.No, 'Template_') }"
                    v-b-tooltip.hover.right="detailValidationText(detail.No, 'Template_', detail)">
                    <select v-model.number="detail.template" @keydown="handleSelectNavigation($event, null, 'template')"
                      @change="pClear(index)">
                      <option value="1">Відсутній</option>
                      <option value="2">Косі різи</option>
                      <option value="3">Фрезерування по дузі</option>
                      <option value="4">Вибірка чверті</option>
                      <option value="5">Паз під ДВП</option>
                      <option value="6">Нестандартне фрезерування</option>
                      <option value="7">Різ під нахилом пили</option>
                      <option value="8">Фрезерування під петлі</option>
                      <option value="9">Виріз для фасаду без ручок</option>

                    </select>
                  </td>
                  <td style="min-width: 110px !important;">
                    <input class="one" type="text" readonly v-model="productName" />
                  </td>
                  <td style="min-width: 110px !important;">
                    <span>
                      <input class="one" placeholder="Деталь" type="text" @keydown="handleNavigation"
                        v-model="detail.detail_name" />
                    </span>
                  </td>

                </tr>
              </tbody>
            </table>

          </form>

          <div class="table-actions-v2">
            <button class="btn btn-primary btn-compact" type="button" v-hotkey="keymap"
              :disabled="materials.length == 0" id="addNewDetail" @click="addNewDetail">
              <i class="fa fa-plus"></i>
              Додати (Alt +)
            </button>
            <button class="btn btn-outline-secondary btn-compact" type="button" :disabled="materials.length == 0"
              @click="exportData">
              <i class="fa fa-download"></i>
              Експорт даних
            </button>
            <button class="btn btn-outline-secondary btn-compact" type="button" @click="fileUploadEvent">
              <i class="fa fa-upload"></i>
              Імпорт даних
            </button>
          </div>
        </div>
      </div>
      <input style="display: none" ref="fileImport" type="file" @change="handleFileUpload" accept=".xls, .xlsx" />
    </div>

    <details v-if="resp">
      <summary>Запит до 1С</summary>
      <pre style="border: 1px solid black">{{ resp.request_data }}</pre>
    </details>
    <details v-if="resp">
      <summary>Відповідь 1С</summary>
      <pre style="border: 1px solid black">{{ resp }}</pre>
    </details>

    <search :materials="materials" :edges="edges" v-bind:what="toSearch" />

    <!-- Модальное окно с горячими клавишами -->
    <b-modal id="hotkeys-modal" size="lg" :title="hotkeysModalTitle" ok-only>
      <div class="row">
        <div class="col-md-6">
          <h6>Основна навігація</h6>
          <table class="table table-sm">
            <tbody>
              <tr>
                <td><kbd>↑</kbd></td>
                <td>Перехід до ячейки вище</td>
              </tr>
              <tr>
                <td><kbd>↓</kbd></td>
                <td>Перехід до ячейки нижче</td>
              </tr>
              <tr>
                <td><kbd>←</kbd></td>
                <td>Перехід до ячейки зліва</td>
              </tr>
              <tr>
                <td><kbd>→</kbd></td>
                <td>Перехід до ячейки справа</td>
              </tr>
              <tr>
                <td><kbd>Enter</kbd></td>
                <td>Перехід до наступної ячейки (як стрілка вправо)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-6">
          <h6>Швидкий вибір в селектах</h6>
          <table class="table table-sm">
            <tbody>
              <tr>
                <td><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>0</kbd></td>
                <td>Вибір "Ні" (для кромок)</td>
              </tr>
              <tr>
                <td><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>1-9</kbd></td>
                <td>Вибір опції за номером</td>
              </tr>
              <tr v-if="!isMac">
                <td><kbd>Ctrl</kbd> + <kbd>цифра</kbd></td>
                <td>Альтернативний спосіб</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <h6>Чекбокси</h6>
          <table class="table table-sm">
            <tbody>
              <tr>
                <td><kbd>Space</kbd></td>
                <td>Перемикання чекбокса</td>
              </tr>
              <tr>
                <td><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>0/1</kbd></td>
                <td>Вимкнути/увімкнути</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-6">
          <h6>Інші</h6>
          <table class="table table-sm">
            <tbody>
              <tr>
                <td><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>+</kbd></td>
                <td>Додати нову деталь</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="alert alert-info mt-3">
        <small>
          <i class="fas fa-info-circle mr-1"></i>
          <strong>Особливості:</strong> Автоматичне створення нових рядків, пропуск недоступних елементів,
          оновлення 2D візуалізації при переході між рядками.
          <br>
          <strong>Примітка:</strong> {{ noteText }}
        </small>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Edges from './EdgeTable.vue'
import Materials from './MaterialsTable.vue'
import Details from './DetailsNameTable.vue'
import Screeds from './Screeds.vue'
import Visual from './Visual.vue'
import Search from "./search.vue";

import axios from "axios";
import appconfig from "../../app/config";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import $ from "jquery";
import { mapState, mapGetters } from 'vuex';

export default {
  name: "product-form",
  components: {
    Edges, Materials, Details, Screeds, Visual, Search
  },
  props: {
    modalShow: Boolean,
    materials: { type: Array, default: () => [] },
    edges: { type: Array, default: () => [] },
    screeds: { type: Array, default: () => [] },
    title: String,
    product: Object,
  },
  data() {
    return {
      loading: false,
      activeIndex: 0,
      resp: null,
      rotateAllValue: 0,
      // Добавляем переменные для навигации по таблице
      currentRow: 0,
      currentCol: 0,
      tableNavigationEnabled: true,
      productName: this.product?.name || '',
      customer_material: this.getDefault('customer_material'),
      edge_size: this.getDefault('edge_size', 'with_edge_sizes'),
      customer_edge: this.getDefault('customer_edge'),
      glue: this.getDefault('glue'),
      toSearch: '',
      selectedDetail: {},
      edgeDefault: this.getDefaultEdge(),
      materialsDefault: this.getDefaultMaterial(),
      detailsName: [],
      details: this.product?.details || [],
      requiredHeaders: [
        "Довжина", "Ширина", "Кількість", "Обертати", "Верх", "Низ", "Ліворуч", "Праворуч", "Матеріал", "Стяжка", "Стяжка БД", "Порізка за текстурою", "Виріб", "Деталь",
      ],
      json_fields: [[
        'Довжина', 'Ширина', 'Кількість', 'Обертати', 'Верх', 'Низ', 'Ліворуч', 'Праворуч', 'Матеріал', 'Стяжка', 'Стяжка БД', 'Порізка за текстурою', 'Виріб', 'Деталь',
      ]],
      connection: {
        connected: true,
        text: '',
        checkedAt: null
      },
      connectionIntervalId: null
    };
  },
  computed: {
    ...mapGetters('data', ['materialColors', 'edgeColors']),
    showEdgeSidesCount() {
      return this.$store.state.auth.settings?.show_edge_sides_count || false;
    },
    keymap() {
      return {
        'alt++': this.addDetailHotKey,
        'alt+=': this.addDetailHotKey,
      }
    },

    // Определяем операционную систему
    isMac() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    },

    // Текст кнопки в зависимости от ОС
    hotkeysButtonText() {
      return 'Гарячі клавіші';
    },

    // Подсказка в зависимости от ОС
    hotkeysTooltip() {
      return this.isMac
        ? 'Гарячі клавіші для навігації (Ctrl + цифра для швидкого вибору)'
        : 'Гарячі клавіші для навігації (Alt + цифра для швидкого вибору)';
    },

    // Заголовок модального окна в зависимости от ОС
    hotkeysModalTitle() {
      return this.isMac
        ? 'Гарячі клавіші для навігації (Mac)'
        : 'Гарячі клавіші для навігації (Windows/Linux)';
    },
    noteText() {
      return this.isMac ? 'На Mac використовуйте Ctrl замість Alt для уникнення конфліктів з браузером.' : 'На Windows / Linux використовуйте Alt для швидкого вибору.';
    },
    is1cConnected() {
      return this.connection.connected === true;
    },
    connectionText() {
      return this.connection.text || '';
    }
  },
  watch: {
    product: {
      handler(value) {
        this.productName = value.name;
        this.customer_material = this.getDefault('customer_material', null, value);
        this.customer_edge = this.getDefault('customer_edge', null, value);
        this.edge_size = this.getDefault('edge_size', 'with_edge_sizes', value);
        this.glue = this.getDefault('glue', null, value);
        this.details = value.details;
        // Устанавливаем дефолтный материал и кромку
        const defaultMaterial = this.getDefaultMaterial();
        const defaultEdge = this.getDefaultEdge();
        this.materialsDefault = defaultMaterial;
        this.edgeDefault = defaultEdge;
        // Обновляем свойство default у всех материалов
        if (this.materials && this.materials.length > 0) {
          this.materials.forEach(material => {
            material.default = material.ref === defaultMaterial.ref ? true : false;
            material.is_default = material.ref === defaultMaterial.ref ? true : false;
          });
        }
        // Обновляем свойство default у всех кромок
        if (this.edges && this.edges.length > 0) {
          this.edges.forEach(edge => {
            edge.default = edge.ref === defaultEdge.ref ? true : false;
            edge.is_default = edge.ref === defaultEdge.ref ? true : false;
          });
        }
        this.visual(0);
        this.details.forEach(detail => this.procesK(detail));
      },
    },
    materials: {
      handler() {
        // При изменении материалов обновляем дефолтный материал
        if (this.materials && this.materials.length > 0) {
          const defaultMaterial = this.getDefaultMaterial();
          this.materialsDefault = defaultMaterial;
          // Обновляем свойство default у всех материалов
          this.materials.forEach(material => {
            material.default = material.ref === defaultMaterial.ref ? true : false;
            material.is_default = material.ref === defaultMaterial.ref ? true : false;
          });
        }
      },
      immediate: true
    },
    edges: {
      handler() {
        // При изменении кромок обновляем дефолтную кромку
        if (this.edges && this.edges.length > 0) {
          const defaultEdge = this.getDefaultEdge();
          this.edgeDefault = defaultEdge;
          // Обновляем свойство default у всех кромок
          this.edges.forEach(edge => {
            edge.default = edge.ref === defaultEdge.ref ? true : false;
            edge.is_default = edge.ref === defaultEdge.ref ? true : false;
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    async fetch1cConnection() {
      try {
        const response = await axios.get(appconfig.Point + 'api/constructor/v1/1c/connection');
        const data = response.data || {};
        this.connection.connected = !!data.connected;
        this.connection.text = data.text || '';
        this.connection.checkedAt = data.checked_at || null;
      } catch (e) {
        this.connection.connected = false;
        this.connection.text = '';
        this.connection.checkedAt = null;
      }
    },
    getDefaultMaterial() {
      if (!this.materials || this.materials.length === 0) return {};
      const defaultMaterial = this.materials.find(m => m.default === true || m.is_default === true);
      return defaultMaterial || this.materials[0];
    },
    getDefaultEdge() {
      if (!this.edges || this.edges.length === 0) return {};
      const defaultEdge = this.edges.find(e => e.default === true || e.is_default === true);
      return defaultEdge || this.edges[0];
    },
    getDefault(field, settingKey = null, obj = null) {
      let settings = this.$store.state.auth.settings;
      const source = obj || this.product || {};
      if (source[field] !== undefined) return source[field];
      if (settingKey && settings && settings[settingKey] !== undefined) return settings[settingKey];
      return false;
    },
    procesK(detail) {
      detail.k1 = (detail.edge_b !== null) + (detail.edge_t !== null);
      detail.k2 = (detail.edge_r !== null) + (detail.edge_l !== null);
    },
    fixedLength(detail, key) {
      detail[key] = detail[key].replace(/[^0-9\.,]+/g, '') == '' ? '' : parseFloat(detail[key]).toFixed(1)
    },
    fileUploadEvent() {
      this.$refs.fileImport.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => this.processExcelFile(e.target.result);
      reader.readAsBinaryString(file);
    },
    processExcelFile(binaryStr) {
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      if (!jsonData.length) {
        this.$toast.error("Файл порожній або має неправильний формат.");
        return;
      }
      const fileHeaders = jsonData[0];
      if (!this.requiredHeaders.every(header => fileHeaders.includes(header))) {
        this.$toast.error("Завантажений файл має неправильні колонки");
        return;
      }
      this.importData(jsonData.slice(1));
      this.$refs.fileImport.value = '';
    },
    importData(data) {
      this.details = data.map((item) => ({
        length: item[0],
        width: item[1],
        count: item[2],
        rotate: item[3] ?? 0,
        edge_t: this.edges[item[4] - 1]?.ref ?? null,
        edge_b: this.edges[item[5] - 1]?.ref ?? null,
        edge_l: this.edges[item[6] - 1]?.ref ?? null,
        edge_r: this.edges[item[7] - 1]?.ref ?? null,
        material: this.materials[item[8] - 1]?.ref ?? null,
        screed: this.screeds.find(screed => screed == item[9]) != undefined || item[9] == 1 ? item[9] : 0,
        screed_bp: item[10] ?? 0,
        cut_to_txtrs: item[11] ?? 0,
        name: this.detailsName[item[12] - 1]?.name ?? '',
        detail_name: item[13],
        template: 1,
        "No": this.details.length > 0 ? this.details[this.details.length - 1]['No'] + 1 : 1,
        "k1": 0,
        "k2": 0,
        "note": '',
        "p1": 0,
        "p2": 0,
        "p3": 0,
        "p4": 0,
        "edge_template": null,
        "file": '',
      }));
      this.details.forEach(detail => this.procesK(detail));
      this.visual(0);
    },
    exportData() {
      const data = this.details.map((detail) => {
        const edgeT = this.edges.findIndex(item => item.ref === detail.edge_t);
        const edgeB = this.edges.findIndex(item => item.ref === detail.edge_b);
        const edgeL = this.edges.findIndex(item => item.ref === detail.edge_l);
        const edgeR = this.edges.findIndex(item => item.ref === detail.edge_r);
        const name = this.detailsName.findIndex(item => item.name === detail.name);
        const material = this.materials.findIndex(item => item.ref === detail.material);
        return [
          detail.length, detail.width, detail.count, detail.rotate,
          edgeT === -1 ? '' : (edgeT + 1), edgeB === -1 ? '' : (edgeB + 1), edgeL === -1 ? '' : (edgeL + 1), edgeR === -1 ? '' : (edgeR + 1),
          material === -1 ? '' : (material + 1), detail.screed, detail.screed_bp, detail.cut_to_txtrs, name == -1 ? '' : (name + 1), detail.detail_name,
        ];
      });
      const worksheet = XLSX.utils.aoa_to_sheet([...this.json_fields, ...data]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Лист1");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, "example.xlsx");
    },
    addDetailHotKey() {
      if (this.materials.length !== 0) {
        this.addNewDetail();
      }
    },
    detailValidation(i, p) {
      if (this.resp?.Parts) {
        let item = this.resp.Parts.find(part => part.No == i);
        if (item) {
          if (item[p] !== undefined) {
            if (item[p] === 0) {
              if (p.includes('Edge')) return 'Вірно: Ні';
              if (p.includes('rotate') || p.includes('screed_bp')) return 'Вірно: Викл(0)';
            }
            return `Вірно: ${item[p]}`;
          }
          if (p === 'Template_') {
            const hasExtendedDetails = ['P1_', 'P2_', 'P3_', 'P4_', 'EdgeA1_'].some(key => item[key] !== undefined);
            if (hasExtendedDetails) return 'Помилка у розширеному деталюванні';
          }
        }
      }
      return '';
    },
    detailValidationText(i, p, detail = null) {
      if (this.resp?.Parts) {
        let item = this.resp.Parts.find(part => part.No == i);
        if (item) {
          if (item[p] !== undefined) {
            if (item[p] === 0) {
              if (p.includes('Edge')) return 'Вірно: Ні';
              if (p.includes('rotate') || p.includes('screed_bp')) return 'Вірно: Викл(0)';
            }
            return `Вірно: ${item[p]}`;
          }
          if (p === 'Template_') {
            const hasExtendedDetails = ['P1_', 'P2_', 'P3_', 'P4_', 'EdgeA1_'].some(key => item[key] !== undefined);
            if (hasExtendedDetails) return 'Помилка у розширеному деталюванні';
          }
        }
      }
      const edgeMap = {
        'EdgeT_': detail?.edge_t,
        'EdgeB_': detail?.edge_b,
        'EdgeL_': detail?.edge_l,
        'EdgeR_': detail?.edge_r
      };

      if (p in edgeMap) {
        return this.edges.find(edge => edge.ref === edgeMap[p])?.full_name ?? '';
      }

      // Проверка на ошибки в p1, p2, p3, p4, edge_template для Template
      if (p === 'Template_' && detail) {
        const hasLocalErrors = detail.p1 !== 0 || detail.p2 !== 0 || detail.p3 !== 0 || detail.p4 !== 0 || detail.edge_template !== null;
        if (hasLocalErrors) {
          return 'Помилка у розширеному деталюванні';
        }
      }

      return '';
    },
    validateOrder() {
      if (document.getElementById('detailTableForm').reportValidity() === false) {
        return false;
      }
      this.loading = true;
      let order = this.getOrderObject();
      order.check_parts = true;
      this.$toast.info("Запит у систему обліку")
      axios.post(
        appconfig.Point + 'api/constructor/v1/order/validate',
        this.getOrderObject()
      ).then(response => {
        response = response.data;
        this.resp = response;
        this.$store.commit('data/SET_RESPONSE_DEBUG', response)
        this.$store.commit('data/SET_RESPONSE', response);
        if (response.Error == true) {
          if (typeof response.ErrorMsg != 'undefined') {
            this.$toast.error(response.ErrorMsg)
          } else {
            this.$toast.error("У деталіровці знайдені помилки! Зверніть увагу на червоні виділення полів, при наведенні на які буде показано правильний варіант.")
          }
        } else {
          this.$toast.success('Помилок не знайдено!')
        }
      }).then(r => {
        this.loading = false;
      })
    },
    // Методы навигации по таблице
    handleTableNavigation(e) {
      if (!this.tableNavigationEnabled) return;

      const key = e.key;
      const activeElement = document.activeElement;

      // Проверяем, что активный элемент находится в таблице
      if (!activeElement || !activeElement.closest('#main_table')) return;

      // Получаем текущую позицию в таблице
      const currentCell = activeElement.closest('td');
      if (!currentCell) return;

      const currentRow = currentCell.closest('tr');
      const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow);
      const colIndex = Array.from(currentRow.children).indexOf(currentCell);

      let nextRow = rowIndex;
      let nextCol = colIndex;

      switch (key) {
        case 'ArrowUp':
          e.preventDefault();
          if (rowIndex > 0) {
            nextRow = rowIndex - 1;
          } else {
            // Если это первая строка, остаемся на месте
            nextRow = 0;
          }
          break;
        case 'ArrowDown':
          e.preventDefault();
          if (rowIndex < this.details.length - 1) {
            nextRow = rowIndex + 1;
          } else {
            // Если это последняя строка, создаем новую
            this.addNewDetail();
            nextRow = this.details.length - 1;
            nextCol = 2;
            // Ждем обновления DOM перед поиском элемента
            this.$nextTick(() => {
              this.focusOnElement(nextRow, nextCol, currentRow, e.key);
              // Автоматический скролл к новой строке
              const tableWrapper = document.querySelector('.table-wrapper-v2');
              if (tableWrapper) {
                tableWrapper.scrollTo({
                  top: tableWrapper.scrollHeight,
                  behavior: 'smooth'
                });
              }
            });
            return;
          }
          break;
        case 'ArrowLeft':
          e.preventDefault();
          if (colIndex <= 0) {
            // Если мы в первой ячейке строки, переходим к предыдущей строке
            if (rowIndex > 0) {
              nextRow = rowIndex - 1;
              nextCol = currentRow.children.length - 1; // Последняя ячейка предыдущей строки
            } else {
              // Если это первая строка, остаемся на месте
              nextCol = 0;
            }
          } else {
            nextCol = colIndex - 1;
          }
          break;
        case 'ArrowRight':
          e.preventDefault();
          if (colIndex >= currentRow.children.length - 1) {
            // Если мы в последней ячейке строки, переходим к следующей строке
            if (rowIndex < this.details.length - 1) {
              nextRow = rowIndex + 1;
              nextCol = 2; // Первая ячейка следующей строки

            } else {
              // Если это последняя строка, создаем новую
              this.addNewDetail();
              nextRow = this.details.length - 1;
              nextCol = 2;
              // Ждем обновления DOM перед поиском элемента
              this.$nextTick(() => {
                this.focusOnElement(nextRow, nextCol, currentRow, e.key);
              });
              return;
            }
          } else {
            nextCol = colIndex + 1;
          }
          break;
        case 'Tab':
          // Используем стандартную навигацию Tab
          return;
        default:
          return;
      }

      // Находим следующий элемент для фокуса
      this.focusOnElement(nextRow, nextCol, currentRow, e.key);
    },

    // Универсальный метод навигации по таблице
    handleNavigation(e) {
      // Обрабатываем стрелки для навигации по таблице
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
        this.handleTableNavigation(e);
        return;
      }

      // Обрабатываем Enter для перехода к следующему элементу (как стрелка вправо)
      if (e.key === 'Enter') {
        e.preventDefault();

        // Получаем текущую позицию в таблице
        const currentRow = e.target.closest('tr');
        if (!currentRow) return;

        const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow);
        const colIndex = Array.from(currentRow.children).indexOf(e.target.closest('td'));

        // Определяем следующую позицию (правая ячейка или следующая строка)
        let nextRow = rowIndex;
        let nextCol = colIndex + 1;

        // Если это последняя ячейка в строке, переходим к следующей строке
        if (nextCol >= currentRow.children.length || nextCol > (this.showEdgeSidesCount ? 6 : 4)) {
          if (rowIndex < this.details.length - 1) {
            nextRow = rowIndex + 1;
            nextCol = 2; // Первая редактируемая ячейка следующей строки
          } else {
            // Если это последняя строка, создаем новую
            this.addNewDetail();
            nextRow = this.details.length - 1;
            nextCol = 2;
            // Ждем обновления DOM перед поиском элемента
            this.$nextTick(() => {
              this.focusOnElement(nextRow, nextCol, currentRow, e.key);
            });
            return;
          }
        }

        // Находим следующий элемент для фокуса
        this.focusOnElement(nextRow, nextCol, currentRow, e.key);
        return;
      }

      // Для всех остальных клавиш (включая Tab) используем стандартное поведение
      return;
    },
    rotateAll() {
      this.rotateAllValue = this.rotateAllValue === 1 ? 0 : 1;
      this.details.forEach((item) => item.rotate = this.rotateAllValue)
    },
    pClear(i) {
      const clearedFields = {
        p1: 0, p2: 0, p3: 0, p4: 0, edge_template: null, note: '', file: ''
      };
      Object.assign(this.details[i], clearedFields);
      if (this.resp?.Parts) {
        let itemKey = Object.keys(this.resp?.Parts).find(key => this.resp?.Parts[key].No == i + 1);
        if (itemKey) {
          ['P1_', 'P2_', 'P3_', 'P4_', 'EdgeA1_'].forEach(key => {
            if (this.resp.Parts[itemKey][key] !== undefined) {
              this.resp.Parts[itemKey][key] = undefined;
            }
          });
        }
      }
    },
    addAdditional(type, data) {
      let newData;
      if (['edges', 'materials'].indexOf(type) !== -1) {
        let usedColors = this[type].map(edge => edge.color);
        let availableColors = type === 'materials' ? this.materialColors : this.edgeColors;
        let freeColors = availableColors.filter(color => !usedColors.includes(color));
        let firstFreeColor = freeColors[0];
        newData = { ...data, color: firstFreeColor == undefined ? '#000000' : firstFreeColor, color_show: false };
        let elem = this[type].find(el => el.ref === data.ref) || null;
        if (elem) return;
      } else {
        newData = data
      }
      this[type].push(newData);
      if (type === 'edges' && Object.keys(this.edgeDefault).length === 0) {
        this.edgeDefault = newData;
      }
      if (type === 'materials' && Object.keys(this.materialsDefault).length === 0) {
        this.materialsDefault = newData;
      }
    },
    replaceProduct(type, newItem, oldRef) {
      const index = this[type].findIndex(el => el.ref === oldRef);
      if (index === -1) return;

      const current = this[type][index];

      // Обновляем детали
      if (type === 'materials') {
        this.details.forEach(detail => {
          if (detail.material === oldRef) {
            detail.material = newItem.ref;
          }
        });
        // Обновляем дефолтный материал если нужно
        if (this.materialsDefault && this.materialsDefault.ref === oldRef) {
          this.materialsDefault = newItem;
        }
      } else if (type === 'edges') {
        this.details.forEach(detail => {
          if (detail.edge_t === oldRef) detail.edge_t = newItem.ref;
          if (detail.edge_b === oldRef) detail.edge_b = newItem.ref;
          if (detail.edge_l === oldRef) detail.edge_l = newItem.ref;
          if (detail.edge_r === oldRef) detail.edge_r = newItem.ref;
          if (detail.edge_template === oldRef) detail.edge_template = newItem.ref;
          this.procesK(detail);
        });
        // Обновляем дефолтную кромку если нужно
        if (this.edgeDefault && this.edgeDefault.ref === oldRef) {
          this.edgeDefault = newItem;
        }
      }

      // Заменяем элемент в массиве
      this.$set(this[type], index, newItem);
    },
    visual(i) {
      this.selectedDetail = this.details[i];
      this.activeIndex = i;
    },
    copyDetail() {
      let d = { ...this.selectedDetail };
      this.details.push(d);
    },
    processDetailsNo() {
      this.details = this.details.map((detail, index) => {
        detail.No = index + 1;
        return detail;
      })
    },
    removeDetail(i) {
      this.details.splice(i, 1);
      if (this.details.length === 0) {
        this.selectedDetail = {};
      } else {
        this.selectedDetail = this.details[this.details.length - 1];
      }
    },
    getOrderObject() {
      this.resp = null;
      let production_params = this.$store.state.auth.user.client.production_params[0];
      this.processDetailsNo();

      // Получаем default материалы и кромки
      const defaultMaterial = this.materialsDefault;
      const defaultEdge = this.edgeDefault;

      return {
        "dept": "ТПМ",
        "section": production_params.section,
        "stock": this.$store.state.auth.user.defaultStock,
        "cy": "980",
        "manager": production_params.manager,
        "price_type": production_params.price_type,
        "draw_cut": false,
        "to_work": false,
        "check_parts": false,
        "customer": this.$store.state.auth.user.client.ref,
        "name": this.productName,
        "customer_material": this.customer_material,
        "customer_edge": this.customer_edge,
        "glue": this.glue,
        "edge_size": this.edge_size,
        "materials_list": this.materials.map(item => {
          return {
            ref: item.ref,
            color: item.color,
            default: item.ref === defaultMaterial?.ref
          }
        }),
        "edge_list": this.edges.map(item => {
          return {
            ref: item.ref,
            color: item.color,
            default: item.ref === defaultEdge?.ref
          }
        }),
        "screed_list": this.screeds,
        "items": this.details.map(detail => {
          detail.name = this.productName;
          return detail
        }),
      };
    },
    save() {
      if (document.getElementById('detailTableForm').reportValidity() === false) {
        return false;
      }
      this.$emit('on-submit', this.getOrderObject());
    },
    addEdge(target, i, t) {
      let value = target.value.trim() || '0';
      value = value.replace(/[^0-9.,]+/g, '').replace(/^0+(?=\d)/, '');
      const max = $(target).attr('max');
      if (max !== undefined && parseFloat(value) > parseFloat(max)) {
        value = max;
      }
      let v = parseInt(value);
      if (isNaN(v) || v < 0) v = 0;
      if (v > 2) v = 2;
      const defEdge = this.edgeDefault;
      if (!this.edges.length || defEdge === undefined) return;
      const edgeRef = defEdge.ref;
      if (t === 1) {
        this.details[i].edge_t = v > 0 ? edgeRef : null;
        this.details[i].edge_b = v === 2 ? edgeRef : null;
        this.details[i].k1 = v;
      }
      if (t === 2) {
        this.details[i].edge_l = v > 0 ? edgeRef : null;
        this.details[i].edge_r = v === 2 ? edgeRef : null;
        this.details[i].k2 = v;
      }
    },
    addNewDetail() {
      let cleanDeteil = {
        "No": this.details.length > 0 ? this.details[this.details.length - 1]['No'] + 1 : 1,
        "length": 20,
        "width": 20,
        "count": 1,
        "rotate": 0,
        "k1": 0,
        "k2": 0,
        "edge_t": null,
        "edge_b": null,
        "edge_l": null,
        "edge_r": null,
        "material": this.materialsDefault ? this.materialsDefault.ref : "",
        "note": '',
        "template": 1,
        "p1": 0,
        "p2": 0,
        "p3": 0,
        "p4": 0,
        "edge_template": null,
        "screed": 0,
        "screed_bp": 0,
        "cut_to_txtrs": 0,
        "name": this.productName,
        "detail_name": '',
        "file": '',
      };
      this.details.push(cleanDeteil);
      this.selectedDetail = this.details[this.details.length - 1];

      // Автоматический скролл к новой строке
      this.$nextTick(() => {
        const tableWrapper = document.querySelector('.table-wrapper-v2');
        if (tableWrapper) {
          tableWrapper.scrollTo({
            top: tableWrapper.scrollHeight,
            behavior: 'smooth'
          });
        }
      });
    },
    checkbox(e, v) {
      // Работает только с Alt+цифра
      if (!e.altKey) return;

      // Получаем текущую строку
      const currentRow = e.target.closest('tr');
      if (!currentRow) return;

      const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow);
      if (rowIndex < 0 || rowIndex >= this.details.length) return;

      if (e.key == 0) {
        this.details[rowIndex][v] = 0;
        this.selectedDetail[v] = 0;
      } else if (e.key == 1) {
        this.details[rowIndex][v] = 1;
        this.selectedDetail[v] = 1;
      }
    },

    // Метод для переключения чекбоксов с помощью пробела
    toggleCheckbox(e, field) {
      if (e.key === ' ') {
        e.preventDefault();
        this.selectedDetail[field] = this.selectedDetail[field] ? 0 : 1;
      }
    },

    // Метод для поиска следующего доступного элемента ввода
    findNextAvailableInput(currentRow, startRow, startCol, direction) {
      const maxRows = this.details.length;
      const maxCols = currentRow.children.length;

      let currentRowIndex = startRow;
      let currentColIndex = startCol;
      let attempts = 0;
      const maxAttempts = maxRows * maxCols; // Максимальное количество попыток

      while (attempts < maxAttempts) {
        attempts++;

        // Определяем следующую позицию в зависимости от направления
        switch (direction) {
          case 'ArrowUp':
            if (currentRowIndex > 0) {
              currentRowIndex = currentRowIndex - 1;
            } else {
              // Если это первая строка, остаемся на месте
              currentRowIndex = 0;
            }
            break;
          case 'ArrowDown':
            if (currentRowIndex < maxRows - 1) {
              currentRowIndex = currentRowIndex + 1;
            } else {
              // Если это последняя строка, создаем новую
              this.addNewDetail();
              currentRowIndex = this.details.length - 1;
              // Ждем обновления DOM перед поиском элемента
              this.$nextTick(() => {
                this.focusOnElement(currentRowIndex, currentColIndex, currentRow, e.key);
              });
              return;
            }
            break;
          case 'ArrowLeft':
            if (currentColIndex > 0) {
              currentColIndex = currentColIndex - 1;
            } else {
              // Если это первая ячейка строки, переходим к предыдущей строке
              if (currentRowIndex > 0) {
                currentRowIndex = currentRowIndex - 1;
                currentColIndex = maxCols - 1;
              } else {
                // Если это первая строка, остаемся на месте
                currentColIndex = 0;
              }
            }
            break;
          case 'ArrowRight':
            if (currentColIndex < maxCols - 1) {
              currentColIndex = currentColIndex + 1;
            } else {
              // Если это последняя ячейка строки, переходим к следующей строке
              if (currentRowIndex < maxRows - 1) {
                currentRowIndex = currentRowIndex + 1;
                currentColIndex = 0;
              } else {
                // Если это последняя строка, создаем новую
                this.addNewDetail();
                currentRowIndex = this.details.length - 1;
                currentColIndex = 0;
                // Ждем обновления DOM перед поиском элемента
                this.$nextTick(() => {
                  this.focusOnElement(currentRowIndex, currentColIndex, currentRow, e.key);
                });
                return;
              }
            }
            break;
        }

        // Получаем элемент в указанной позиции
        const rowElement = currentRow.parentElement.children[currentRowIndex];
        if (!rowElement) continue;

        const cellElement = rowElement.children[currentColIndex];
        if (!cellElement) continue;

        // Проверяем, есть ли в ячейке интерактивные элементы
        const hasInteractiveElements = this.hasInteractiveElements(cellElement);

        if (hasInteractiveElements) {
          // Ищем элемент ввода в ячейке
          let inputElement = cellElement.querySelector('input:not([type="button"]):not([type="submit"]), select, textarea');
          if (inputElement && !inputElement.disabled && !inputElement.readOnly) {
            // Нашли доступный элемент, устанавливаем фокус
            if (inputElement.type === 'checkbox') {
              setTimeout(() => {
                inputElement.focus();
              }, 10);
            } else {
              inputElement.focus();
              if (typeof inputElement.select === 'function') {
                inputElement.select();
              }
            }
            // Автоматический скролл к элементу
            this.scrollToElement(cellElement);

            // Обновляем активную строку для визуализации
            this.visual(currentRowIndex);
            return;
          }
        }
      }

      // Если не нашли доступный элемент, останавливаемся
      console.log('Не найдено доступных элементов для навигации');
    },

    // Метод для проверки наличия интерактивных элементов в ячейке
    hasInteractiveElements(cellElement) {
      // Проверяем наличие различных типов интерактивных элементов
      const hasInput = cellElement.querySelector('input:not([type="button"]):not([type="submit"])') !== null;
      const hasSelect = cellElement.querySelector('select') !== null;
      const hasTextarea = cellElement.querySelector('textarea') !== null;
      const hasCheckbox = cellElement.querySelector('input[type="checkbox"]') !== null;

      // Проверяем, что ячейка не содержит только текст или кнопки
      const hasOnlyText = cellElement.textContent.trim() !== '' &&
        !hasInput && !hasSelect && !hasTextarea && !hasCheckbox;
      const hasOnlyButtons = cellElement.querySelectorAll('button, input[type="button"], input[type="submit"]').length > 0 &&
        !hasInput && !hasSelect && !hasTextarea && !hasCheckbox;

      // Проверяем, что ячейка не пустая (без элементов и текста)
      const isEmpty = cellElement.textContent.trim() === '' &&
        !hasInput && !hasSelect && !hasTextarea && !hasCheckbox &&
        cellElement.querySelectorAll('button, input[type="button"], input[type="submit"]').length === 0;

      // Возвращаем true только если есть интерактивные элементы и нет только текста/кнопок/пустых ячеек
      return (hasInput || hasSelect || hasTextarea || hasCheckbox) && !hasOnlyText && !hasOnlyButtons && !isEmpty;
    },
    checkboxChange(val, v) {
      this.details[v] = val ? 1 : 0;
    },
    onFileChanged($event, v) {
      const target = $event.target;
      if (target && target.files) {
        this.details[v] = target.files[0];
      }
    },
    // Универсальный обработчик для селектов с поддержкой навигации и быстрого выбора
    handleSelectNavigation(e, data, field) {
      // Обработка стрелок и Enter для навигации
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter'].includes(e.key)) {
        e.preventDefault();

        // Получаем текущую позицию в таблице
        const currentRow = e.target.closest('tr');
        if (!currentRow) return;

        const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow);
        const colIndex = Array.from(currentRow.children).indexOf(e.target.closest('td'));

        let nextRow = rowIndex;
        let nextCol = colIndex;

        // Определяем следующую позицию в зависимости от направления
        switch (e.key) {
          case 'ArrowUp':
            if (rowIndex > 0) {
              nextRow = rowIndex - 1;
            }
            break;
          case 'ArrowDown':
            if (rowIndex < this.details.length - 1) {
              nextRow = rowIndex + 1;
            } else {
              // Если это последняя строка, создаем новую
              this.addNewDetail();
              nextRow = this.details.length - 1;
              // Ждем обновления DOM перед поиском элемента
              this.$nextTick(() => {
                this.focusOnElement(nextRow, nextCol, currentRow, e.key);
              });
              return;
            }
            break;
          case 'ArrowLeft':
            if (colIndex > 0) {
              nextCol = colIndex - 1;
            } else {
              // Если это первая ячейка строки, переходим к предыдущей строке
              if (rowIndex > 0) {
                nextRow = rowIndex - 1;
                nextCol = currentRow.children.length - 1;
              }
            }
            break;
          case 'ArrowRight':
          case 'Enter':
            if (colIndex < currentRow.children.length - 1) {
              nextCol = colIndex + 1;
            } else {
              // Если это последняя ячейка строки, переходим к следующей строке
              if (rowIndex < this.details.length - 1) {
                nextRow = rowIndex + 1;
                nextCol = 2; // Первая редактируемая ячейка следующей строки
              } else {
                // Если это последняя строка, создаем новую
                this.addNewDetail();
                nextRow = this.details.length - 1;
                nextCol = 2;
                // Ждем обновления DOM перед поиском элемента
                this.$nextTick(() => {
                  this.focusOnElement(nextRow, nextCol, currentRow, e.key);
                });
                return;
              }
            }
            break;
        }

        // Находим следующий элемент для фокуса
        this.focusOnElement(nextRow, nextCol, currentRow, e.key);
        return;
      }

      // Обработка цифр для быстрого выбора (Alt+цифра или Ctrl+цифра)
      if (/^[0-9]$/.test(e.key) && (e.altKey || e.ctrlKey)) {
        e.preventDefault();
        let val = e.key;

        // Специальная обработка для template (числовые значения)
        if (field === 'template') {
          if (val >= '1' && val <= '9') {
            this.detail[field] = parseInt(val);
          }
          return;
        }

        // Обработка для остальных селектов
        if (val === '0' && field !== 'template') {
          this.detail[field] = null;
        } else if (+val - 1 >= 0 && data && data[val - 1]) {
          // Для detailsName используем name, для остальных - ref
          if (field === 'name' && data[val - 1].name) {
            this.detail[field] = data[val - 1].name;
          } else if (data[val - 1].ref !== undefined) {
            this.detail[field] = data[val - 1].ref;
          }
        }
        return;
      }

      // Для всех остальных клавиш используем стандартное поведение
      return;
    },

    selectByKey(e, data, v) {
      // Работает с Alt+цифра (Win/Linux) или Ctrl+цифра (Mac)
      if (!(e.altKey || e.ctrlKey)) return;
      let val = e.key;
      if (/^[0-9]$/.test(val)) {
        if (val === '0' && v !== 'template') {
          this.details[v] = null;
        } else if (+val - 1 >= 0 && data[val - 1] && data[val - 1].ref !== undefined) {
          this.details[v] = data[val - 1].ref;
        }
      }
    },
    onlyNumeric(e) {
      if (e.target.value == '') {
        e.target.value = 0;
        return;
      }
      e.target.value = e.target.value.replace(/^0+(?=\d)/, '')
      let max = $(e.target).attr('max');
      if (e.key != '.' && e.key != ',') {
        e.target.value = e.target.value.replace(/[^0-9\.,]+/g, '')
      }
      if (max != undefined && max < e.target.value) {
        e.target.value = max
      }
    },

    // Метод для показа справки по горячим клавишам
    showHotkeysHelp() {
      this.$bvModal.show('hotkeys-modal');
    },

    // Метод для обновления материала с реактивностью
    updateMaterial(index, value) {
      this.$set(this.details[index], 'material', value);
      this.procesK(this.details[index]);
    },
    getMaterialSelectStyle(materialRef) {
      const material = this.materials.find(m => m.ref === materialRef);
      if (material && material.color) {
        const contrastColor = this.getContrastColor(material.color);
        return {
          backgroundColor: material.color,
          color: contrastColor,
          borderColor: contrastColor,
        };
      }
      return {};
    },
    getEdgeSelectStyle(edgeRef) {
      const edge = this.edges.find(m => m.ref === edgeRef);
      if (edge && edge.color) {
        const contrastColor = this.getContrastColor(edge.color);
        return {
          backgroundColor: edge.color,
          color: contrastColor,
          borderColor: contrastColor,
        };
      }
      return {};
    },

    // Метод для получения контрастного цвета
    getContrastColor(hexColor) {
      if (!hexColor) return '#000000';

      // Убираем # если есть
      const hex = hexColor.replace('#', '');

      // Конвертируем в RGB
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      // Вычисляем яркость
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // Возвращаем белый для темных цветов, черный для светлых
      return brightness > 128 ? '#000000' : '#ffffff';
    },


    // Метод для фокусировки на элементе
    focusOnElement(rowIndex, colIndex, currentRow, key) {
      const nextRowElement = currentRow.parentElement.children[rowIndex];
      if (nextRowElement) {
        const nextCell = nextRowElement.children[colIndex];

        if (nextCell) {
          // Ищем все возможные элементы ввода
          let nextInput = nextCell.querySelector('input, select, textarea');

          // Если не нашли, попробуем найти чекбокс отдельно
          if (!nextInput) {
            nextInput = nextCell.querySelector('input[type="checkbox"]');
          }

          // Если все еще не нашли, попробуем найти любой input
          if (!nextInput) {
            nextInput = nextCell.querySelector('input');
          }

          if (nextInput) {
            // Проверяем, не disabled ли элемент и не readonly
            if (nextInput.disabled || nextInput.readOnly) {
              // Если элемент недоступен, рекурсивно ищем следующий
              this.findNextAvailableInput(currentRow, rowIndex, colIndex, key);
              return;
            }

            // Для чекбоксов используем специальную логику фокуса
            if (nextInput.type === 'checkbox') {
              // Добавляем небольшую задержку для корректного фокуса на чекбоксе
              setTimeout(() => {
                nextInput.focus();
              }, 10);
            } else {
              nextInput.focus();
              if (typeof nextInput.select === 'function') {
                nextInput.select();
              }
            }

            // Автоматический скролл к элементу
            this.scrollToElement(nextCell);

            // Обновляем активную строку для визуализации
            this.visual(rowIndex);
          } else {
            this.findNextAvailableInput(currentRow, rowIndex, colIndex, key);
          }
        }
      }
    },

    // Метод для автоматического скролла к элементу
    scrollToElement(element) {

      const tableWrapper = document.querySelector('.table-wrapper-v2');

      if (!tableWrapper) return;

      const elementRect = element.getBoundingClientRect();
      const wrapperRect = tableWrapper.getBoundingClientRect();

      // Получаем высоту шапки таблицы
      const tableHeader = tableWrapper.querySelector('thead');
      const headerHeight = 80;

      // Проверяем, виден ли элемент (учитываем высоту шапки)
      const isVisible = (
        elementRect.top >= (wrapperRect.top + headerHeight) &&
        elementRect.bottom <= wrapperRect.bottom &&
        elementRect.left >= wrapperRect.left &&
        elementRect.right <= wrapperRect.right
      );

      console.log(isVisible);
      if (!isVisible) {
        // Вычисляем необходимый скролл
        let scrollTop = tableWrapper.scrollTop;
        let scrollLeft = tableWrapper.scrollLeft;

        // Вертикальный скролл
        if (elementRect.top < (wrapperRect.top + headerHeight)) {
          // Элемент выше видимой области (учитываем шапку)
          scrollTop -= (wrapperRect.top + headerHeight - elementRect.top) + 10;
        } else if (elementRect.bottom > wrapperRect.bottom) {
          // Элемент ниже видимой области
          scrollTop += (elementRect.bottom - wrapperRect.bottom) + 10;
        }

        // Горизонтальный скролл
        if (elementRect.left < wrapperRect.left) {
          // Элемент левее видимой области
          scrollLeft -= (wrapperRect.left - elementRect.left) + 10;
        } else if (elementRect.right > wrapperRect.right) {
          // Элемент правее видимой области
          scrollLeft += (elementRect.right - wrapperRect.right) + 10;
        }

        // Применяем скролл с плавной анимацией
        tableWrapper.scrollTo({
          top: Math.max(0, scrollTop),
          left: Math.max(0, scrollLeft),
          behavior: 'smooth'
        });
      }
    }
  },
  created() {
    this.$root.$off('on-save-product');
    this.$root.$off('on-replace-product');
    this.$root.$off('on-remove');
    this.$root.$off('setEdgeDefault');
    this.$root.$off('setMaterialDefault');
    this.$root.$on('on-save-product', (type, data) => {
      this.addAdditional(type, data);
    });
    this.$root.$on('on-replace-product', (type, newItem, oldRef) => {
      this.replaceProduct(type, newItem, oldRef);
    });
    this.$root.$on('on-remove', (type, index) => {
      if (type == 'screeds') {
        let currentScreed = this[type][index];
        this.details.map((detail) => {
          if (detail.screed == currentScreed) {
            detail.screed = 0;
          }
          return detail;
        });
      }
      this[type].splice(index, 1);
    });
    this.$root.$on('setEdgeDefault', (value) => {
      this.edgeDefault = value;
      // Обновляем свойство default у всех кромок
      if (this.edges && this.edges.length > 0) {
        this.edges.forEach(edge => {
          edge.default = edge.ref === value.ref ? true : false;
          edge.is_default = edge.ref === value.ref ? true : false;
        });
      }
    });
    this.$root.$on('setMaterialDefault', (value) => {
      this.materialsDefault = value;
      // Обновляем свойство default у всех материалов
      if (this.materials && this.materials.length > 0) {
        this.materials.forEach(material => {
          material.default = material.ref === value.ref ? true : false;
          material.is_default = material.ref === value.ref ? true : false;
        });
      }
    });
    this.fetch1cConnection();
    this.connectionIntervalId = setInterval(this.fetch1cConnection, 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.connectionIntervalId) {
      clearInterval(this.connectionIntervalId);
      this.connectionIntervalId = null;
    }
  }
}
</script>

<style scoped>
/* Modern Product Form Styles */
.product-form-v2 {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #2c3e50;
  background: #f8f9fa;
  min-height: 100vh;
  padding: 18px;
}

/* Layout Structure */
.form-layout-v2 {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  gap: 18px;
  max-width: 1600px;
  margin: 0 auto;
}

.form-sidebar-v2 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: fit-content;
  top: 20px;
}

.visual-section-v2 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  height: fit-content;
}

/* Panels Styling */
.form-panels-v2 {
  display: flex;
  flex-direction: column;
}

.panel-card-v2 {
  border-bottom: 1px solid #e9ecef;
}

.panel-card-v2:last-child {
  border-bottom: none;
}

.panel-header-v2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  outline: none;
}

.panel-header-v2:hover {
  background: #e9ecef;
}

.panel-header-v2[aria-expanded="true"] {
  background: #2c5aa0;
  color: white;
}

.panel-header-v2[aria-expanded="true"] .panel-arrow-v2 {
  transform: rotate(180deg);
  color: white;
}

.panel-title-v2 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
}

.panel-title-v2 i {
  color: #2c5aa0;
  font-size: 1rem;
}

.panel-header-v2[aria-expanded="true"] .panel-title-v2 i {
  color: white;
}

.panel-arrow-v2 {
  transition: transform 0.3s ease;
  color: #6c757d;
  font-size: 0.9rem;
}

.panel-content-v2 {
  /* padding: 15px 16px; */
  background: white;
  border-top: 1px solid #e9ecef;
}

/* Checkbox Grid */
.checkbox-grid-v2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 12px;
}

.checkbox-item-v2 {
  position: relative;
}

.checkbox-v2 {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label-v2 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
}

.checkbox-label-v2:hover {
  background: #e9ecef;
  border-color: #2c5aa0;
}

.checkbox-v2:checked+.checkbox-label-v2 {
  background: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}

.checkbox-label-v2 i {
  font-size: 0.9rem;
  width: 18px;
  text-align: center;
}

/* Input Styling */
.input-group-v2 {
  position: relative;
}

.form-input-v2 {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e9ecef;
  border-radius: 7px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: white;
}

.form-input-v2:focus {
  outline: none;
  border-color: #2c5aa0;
  box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1);
}

.form-input-v2::placeholder {
  color: #6c757d;
}

/* Component Wrapper */
.component-wrapper-v2 {
  background: #f8f9fa;
  border-radius: 8px;
}

/* Action Buttons */
.action-buttons-v2 {
  display: flex;
  flex-direction: row;
  gap: 6px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  justify-content: space-between;
  width: 100%;
}

.action-buttons-v2 .btn-compact {
  flex: 1;
  min-width: 0;
}

/* Compact Button Styles */
.btn-compact {
  padding: 6px 10px;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  transition: all 0.3s ease;
}

.btn-compact:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-compact:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.btn-compact i {
  font-size: 0.75rem;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff4f4;
  color: #b02a37;
  font-size: 0.85rem;
  border: 1px solid #f5c2c7;
}

.connection-status i {
  font-size: 0.9rem;
}

/* Primary Button */
.btn-primary.btn-compact {
  background: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}

.btn-primary.btn-compact:hover:not(:disabled) {
  background: #19469e;
  border-color: #19469e;
}


/* Visual Section */
.visual-card-v2 {
  height: 100%;
}

.visual-header-v2 {
  padding: 15px 18px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.visual-header-v2 h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2c3e50;
}

.visual-header-v2 i {
  color: #2c5aa0;
}

.visual-content-v2 {
  padding: 18px;
  background: white;
}

/* Table Section */
.table-section-v2 {
  margin-top: 18px;
}

.table-card-v2 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.table-header-v2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.table-title-v2 {
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2c3e50;
  margin: 0;
}

.table-title-v2 i {
  color: #2c5aa0;
  font-size: 1.1rem;
}

.table-content-v2 {
  background: white;
}

.table-wrapper-v2 {
  position: relative;
  overflow: auto;
  max-height: 500px;
  max-width: 100%;
}

/* Button Styles */
.btn-v2 {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  white-space: nowrap;
  justify-content: center;
}

.btn-v2 i {
  font-size: 0.75rem;
}

.btn-primary-v2 {
  background: #28a745;
  border: 1px solid #28a745;
  color: white;
}

.btn-primary-v2:hover:not(:disabled) {
  background: #1e7e34;
  border-color: #1e7e34;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-outline-v2 {
  background: white;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.btn-outline-v2:hover:not(:disabled) {
  background: #6c757d;
  border-color: #6c757d;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Info button for table actions */
.btn-info-v2 {
  background: #17a2b8;
  border: 1px solid #17a2b8;
  color: white;
}

.btn-info-v2:hover:not(:disabled) {
  background: #138496;
  border-color: #138496;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Danger outline for table actions */
.btn-outline-danger-v2 {
  background: white;
  color: #dc3545;
  border: 1px solid #dc3545;
}

.btn-outline-danger-v2:hover:not(:disabled) {
  background: #dc3545;
  border-color: #dc3545;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-v2:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-v2[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}


/* Active Row Styling */
tr.active {
  background-color: rgba(44, 90, 160, 0.3) !important;
}

/* Стили для всех option элементов с увеличенным размером шрифта */
select option {
  font-size: 16px;
  font-weight: 500;
  padding: 0.5rem;
}

select option:selected {
  font-weight: 600;
}

/* Стили для select с цветами материалов */
.custom-select.material {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
}

.custom-select.material:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.custom-select.material option {
  padding: 0.5rem;
  background-color: #fff;
  color: #212529;
  font-size: 16px;
  font-weight: 500;
}

.custom-select.material option:hover {
  background-color: #f8f9fa;
}

.custom-select.material option:selected {
  background-color: #0d6efd;
  color: #fff;
  font-weight: 600;
}

/* Стили для таблицы с правильным скроллом */
.table-wrapper-v2 {
  position: relative;
  overflow: auto;
  max-height: 500px;
  max-width: 100%;
}

.main_table {
  width: auto !important;
  min-width: 100%;
  padding-bottom: 5px !important;
  border-collapse: separate;
  border-spacing: 0;
}

.main_table thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
}

.main_table thead th {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
  border-bottom: 1px solid #dee2e6;
}

.main_table thead tr:first-child th {
  top: 0;
  border-bottom: 1px solid #dee2e6;
}

.main_table thead tr:nth-child(2) th {
  top: 50px;
  border-bottom: 1px solid #dee2e6;
}

.main_table tbody td {
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

/* Улучшенные стили для скролла */
.table-wrapper-v2::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-wrapper-v2::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-wrapper-v2::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-wrapper-v2::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.main_table td,
.main_table th {
  padding: .15rem !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap;
}

.main_table td input:not([type='checkbox']) {
  width: 46px;
  border: none;
  padding: 6px 0 7px 3px;
  margin: -2px;
}

.main_table td .one {
  width: 55px !important;
  border: none;
}

.main_table td .one-qt {
  width: 28px !important;
  border: none;
}

.main_table td .sm-one {
  width: 15px !important;
  border: none;
}

.main_table td .two {
  width: 70px;
  border: none;
}

.main_table td .three {
  width: 100%;
  border: none;
}

.main_table input[name="note"] {
  width: 100px;
}

.main_table td select {
  width: 100px;
  border: none;
  font-size: 12px !important;
}

.main_table td select option {
  font-size: 16px;
  font-weight: 500;
  padding: 0.5rem;
}

.main_table td select option:selected {
  font-weight: 600;
}


.main_table tbody td {
  padding: 8px;
  border-right: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}

.main_table tbody tr:hover {
  background: rgba(44, 90, 160, 0.05);
}

/* Custom Scrollbar */
.table-wrapper-v2::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-wrapper-v2::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-wrapper-v2::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-wrapper-v2::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Mobile Responsiveness */
@media (max-width: 1200px) {
  .form-layout-v2 {
    grid-template-columns: 0.8fr 1.2fr;
    gap: 15px;
  }

  .product-form-v2 {
    padding: 15px;
  }
}

@media (max-width: 992px) {
  .form-layout-v2 {
    grid-template-columns: 1fr;
    gap: 20px;
  }


  .table-wrapper-v2 {
    max-height: 400px;
  }
}

@media (max-width: 768px) {
  .product-form-v2 {
    padding: 10px;
  }

  .panel-header-v2 {
    padding: 10px 12px;
  }

  .panel-content-v2 {
    padding: 12px 14px;
  }

  .checkbox-grid-v2 {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .checkbox-label-v2 {
    padding: 8px 10px;
    font-size: 0.8rem;
  }

  .table-header-v2 {
    padding: 12px 14px;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }

  .action-buttons-v2 {
    padding: 12px 14px;
  }

  .main_table {
    font-size: 0.8rem;
  }

  .main_table thead th {
    padding: 8px 6px;
    font-size: 0.75rem;
  }

  .main_table tbody td {
    padding: 6px;
  }
}

@media (max-width: 480px) {
  .product-form-v2 {
    padding: 5px;
  }

  .table-section-v2 {
    margin-top: 15px;
  }

  .btn-v2 {
    padding: 8px 12px;
    font-size: 0.8rem;
  }

  .panel-title-v2 {
    font-size: 0.85rem;
  }

  .table-title-v2 {
    font-size: 1rem;
  }
}

/* Focus States */
.panel-header-v2:focus {
  outline: 2px solid #2c5aa0;
  outline-offset: 2px;
}

.btn-v2:focus {
  outline: 2px solid #2c5aa0;
  outline-offset: 2px;
}

/* Animation for Accordion */
.panel-content-v2.collapsing {
  transition: height 0.35s ease;
}

/* Legacy button compatibility */
.button-list {
  display: none;
}
</style>
